// src/menu/sections/sshMenu.ts
import type { AppMenuEntry } from "../types";

export const SSH_MENU: AppMenuEntry = {
  type: "group",
  key: "ssh",
  label: "SSH",
  children: [
    {
      key: "sshcertcontrol",
      label: "SSH Cert Control",
      path: "/sshcertcontrol",
      componentKey: "sshCertControl",
      icon: "certificate",
    },
  ],
};
